<template>
  <div class="two-column-view">
    <div class="article-content">
      <h1>投资者中心</h1>
      <p>
        <strong>Goldenlink+ 投资者中心向大小投资者开放。</strong><br />
        我们目前为即将到来的ICO投资提供白名单机会。
      </p>
      <p><strong>享受我们的白名单优势</strong></p>
      <ol>
        <li>以初始价格获得同等份额的流量代币——GSCoin。</li>
        <li>
          GOLD将保留基金池年度利润的5%，并相应分配给每位投资者。未来，GOLD还将根据业务和发展需要，预留ICO投融资机会。
        </li>
        <li>
          随着平台规模的不断扩大，GOLD将升级更多矿工功能和福利，并优先处理您的申请。如果您想限制支出，可以申请将您的ICO投资选择到相应的矿区。
        </li>
        <li>
          使用我们的NFT拍卖或市场交易功能作为退出策略，将股权、权利和利益转让给其他矿工或买方。更多详情，请查看我们的条款与条件。
        </li>
      </ol>
      <p>要申请加入白名单，请点击下面的按钮</p>
      <div v-if="showForm" class="application-form">
        <InvestorForm @submitted="showForm = false" />
      </div>
      <div v-else @click="showForm = true" class="btn btn-gold px-5 text-white">
        立即申请
      </div>
    </div>
    <div class="right-side-column">
      <div class="column-image">
        <img src="../../assets/Investors.png" alt="Investors" />
      </div>
      <p>请联系Goldenlink+安排预约。</p>
    </div>
  </div>
</template>

<script>
import InvestorForm from "@/components/InvestorForm.vue";

export default {
  data() {
    return {
      showForm: false,
    };
  },
  components: {
    InvestorForm,
  },
};
</script>

<style scoped></style>
